import { render, staticRenderFns } from "./AddShip2DbDialog.vue?vue&type=template&id=7c061871&scoped=true"
import script from "./AddShip2DbDialog.vue?vue&type=script&lang=js"
export * from "./AddShip2DbDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c061871",
  null
  
)

export default component.exports